// extracted by mini-css-extract-plugin
export default {"form":"CreateRiskRegisterForm_form__u6XHC"};